// Replacing and removing PRA files (Stage 2, revises Q3, decided 27 Oct 2026). Plain module with
// no Vue, so it runs under `node --test`. Cosmetic only: the API decides (pra/files.js), with
// 403 not_uploader / not_manager, 422 reason_required and 422 file_required. The CRD and the
// receipt are only replaced; optional documents (the request, later the hold) also get "Rimuovi".

import { REMOVE_ANY_ROLES, checkUpload } from "./dossierFiles.mjs";

// Who may change the file: null when the user may not, otherwise { reasonRequired }.
// While the case is not confirmed: the uploader (reason optional) or a Manager / Admin (reason
// required for someone else's file). Once confirmed: a Manager / Admin, always with a reason.
export function praFileAccess(file, { role, userId, caseState } = {}) {
  if (!file) return null;
  const manager = REMOVE_ANY_ROLES.includes(role);
  if (caseState === "confirmed") {
    return manager ? { reasonRequired: true } : null;
  }
  const uploader = file.uploadedBy && file.uploadedBy.userId;
  if (uploader && userId && String(uploader) === String(userId)) {
    return { reasonRequired: false };
  }
  return manager ? { reasonRequired: true } : null;
}

// What blocks "Sostituisci": { file?, reason? } with "required", "too_large" or "unsupported_type".
export function replaceFormErrors({ file, reason }, { reasonRequired }) {
  const errors = {};
  if (!file) errors.file = "required";
  else {
    const problem = checkUpload(file, "pra");
    if (problem) errors.file = problem;
  }
  if (reasonRequired && !String(reason || "").trim())
    errors.reason = "required";
  return errors;
}

// What blocks "Rimuovi": { reason? } with "required".
export function removeFormErrors({ reason }, { reasonRequired }) {
  return reasonRequired && !String(reason || "").trim()
    ? { reason: "required" }
    : {};
}

// A retry of the same change reuses its commandId. A removal has no file.
export function replaceSubmitKey(fileId, { file, reason }) {
  const f = file || {};
  return [
    fileId,
    f.name,
    f.size,
    f.lastModified,
    String(reason || "").trim(),
  ].join("|");
}

// A failed change -> acceptance.pra.file_change.errors.<key>, or null to show the API's errorMsg.
const ERROR_CODES = [
  "not_uploader",
  "not_manager",
  "reason_required",
  "file_required",
  "unsupported_type",
  "not_found",
];

export function praFileErrorKey(err) {
  const res = err && err.response;
  if (!res) return null;
  if (res.status === 413) return "too_large";
  const code = res.data && res.data.code;
  return ERROR_CODES.includes(code) ? code : null;
}
